export function productCodeDisplay(code?: string, customSku?: string) {
  const normalizedCode = code?.trim() || '—'
  const normalizedCustomSku = customSku?.trim()
  if (!normalizedCustomSku || normalizedCustomSku === normalizedCode) {
    return { primary: normalizedCode, secondary: undefined }
  }
  return { primary: normalizedCode, secondary: normalizedCustomSku }
}
